import { render, staticRenderFns } from "./PhotoImage.vue?vue&type=template&id=fc4905de&scoped=true"
import script from "./PhotoImage.vue?vue&type=script&lang=js"
export * from "./PhotoImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4905de",
  null
  
)

export default component.exports